// extracted by mini-css-extract-plugin
export default {"icon":"tooltip_icon__rJBxh"};